import React from "react";

import { Stack } from "@mui/material";

import ErrorOrChildren from "../../../components/meeting/core/error-or-children";
import { LocalViewTile } from "../../../components/meeting/video/tiles";
import HeadsetControlBar from "../../../components/meeting/bars/headset-control-bar/headset-control-bar";

const HeadsetLayout: React.FC = () => {
  const viewHeight = 100;
  const viewWidth = 100;

  return (
    <div
      style={{
        height: "100vh",
        width: "100vw",
        backgroundColor: "#2E3033",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Stack
        direction={"column"}
        alignContent={"center"}
        justifyContent={"center"}
        alignItems={"center"}
        justifyItems={"center"}
        sx={{
          position: "absolute",
          top: "8px",
          left: "50%",
          transform: "translateX(-50%)",
          width: "100%",
          zIndex: 2,
        }}
      >
        <HeadsetControlBar />
      </Stack>
      <Stack
        alignContent={"center"}
        justifyContent={"center"}
        alignItems={"center"}
        justifyItems={"center"}
        height={"100%"}
        width={"100%"}
        aria-hidden={true}
      >
        <ErrorOrChildren>
          <LocalViewTile
            showErrorMessage={true}
            viewHeight={viewHeight}
            viewWidth={viewWidth}
          />
        </ErrorOrChildren>
      </Stack>
    </div>
  );
};

export default HeadsetLayout;
